import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { UploadIds } from '../../../models/upload';
import { ModuleItem } from '../../../models/module-item';
import { ModuleItemsConfig } from '../../../models/module-items-config';
import { ApiService } from '../../../core/services/api/api.service';
import { ModuleItemImport } from '../../../models/module-item-import';

@Injectable({
  providedIn: 'root',
})
export class ModuleItemService {
  getModuleItemConfigs(): Observable<ModuleItemsConfig[]> {
    return this.apiService.get<ModuleItemsConfig[]>(`/item-config`);
  }

  createModuleItem(studyId: number, moduleId: number, moduleItem: ModuleItem): Observable<ModuleItem> {
    return this.apiService.post<ModuleItem>(`/dashboard/study/${studyId}/module/${moduleId}/item`, moduleItem);
  }

  updateModuleItem(studyId: number, moduleId: number, moduleItem: ModuleItem): Observable<ModuleItem> {
    return this.apiService.put<ModuleItem>(
      `/dashboard/study/${studyId}/module/${moduleId}/item/${moduleItem?.id}`,
      moduleItem
    );
  }

  deleteModuleItem(studyId: number, moduleId: number, moduleItemId: number): Observable<ModuleItem> {
    return this.apiService.delete<ModuleItem>(`/dashboard/study/${studyId}/module/${moduleId}/item/${moduleItemId}`);
  }

  saveModuleItemSortingOrder(studyId: number, moduleId: number, sortingOrder: number[]): Observable<number[]> {
    return this.apiService.put<number[]>(`/dashboard/study/${studyId}/module/${moduleId}/itemsort`, sortingOrder);
  }

  uploadModuleItemFile(imageFile: File, idsForUpload: UploadIds): Observable<HttpEvent<string>> {
    const body: FormData = new FormData();
    body.append('uploads[]', imageFile, imageFile.name);
    return this.apiService.post<HttpEvent<string>>(
      `/dashboard/study/${idsForUpload?.studyId || 0}/module/${idsForUpload?.moduleId || 0}/item/upload`,
      body,
      {
        reportProgress: true,
        observe: 'events',
      }
    );
  }

  importModuleItems(moduleFile: File, idsForUpload: UploadIds): Observable<ModuleItemImport> {
    const body: FormData = new FormData();
    body.append('uploads[]', moduleFile, moduleFile.name);
    return this.apiService.post<ModuleItemImport>(
      `/dashboard/study/${idsForUpload.studyId || 0}/module/${idsForUpload.moduleId || 0}/import`,
      body
    );
  }

  constructor(private apiService: ApiService) {}
}
